<template>
  <div class="detail-container">
    <Card>
      111
    </Card>
  </div>
</template>

<script>
import Card from './detailComponents/Card.vue';

export default {
  name: 'DetailView',
  components: {
    Card
  },
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style scoped>
.detail-container {
  width: 100%;
  height: 100%;
  background-color: #000;
}
</style>
